

<div *ngIf="breadcrumbs" style="padding:3px 10px;height:36px;line-height:30px;font-size:medium;background-color:#fff;color:#333;font-weight:bold;font-family:'Microsoft YaHei'">
  <span><a [routerLink]="['/home']" style="text-decoration:none;"> 首頁 </a></span>

  <span *ngFor="let breadcrumb of breadcrumbs">
    <img *ngIf="breadcrumb.label" style="height:17px;margin-left:10px;margin-right:10px" src="../../../assets/backgroundImgs/iconfinder_Arrow_doodle_03_3847904.png" />
    <a [routerLink]="[breadcrumb.url, breadcrumb.params]" style="text-decoration:none;"> {{ breadcrumb.label }} </a>
  </span>

  <!--<img *ngIf="!globalVar.menuShow" src="../../../assets/backgroundImgs/長方形.jpg" style="margin:1px 8px;float:right;height:28px" />-->
  <span *ngIf="globalVar.menuShow" style="display: inline-block; margin: 1px 8px; float: right; height: 28px;font-weight:bold;color:#888;font-style:italic">無敵雲課程管理系統</span>
  <span *ngIf="!globalVar.menuShow" style="display: inline-block; margin: 1px 8px; float: right; height: 28px;font-weight:bold;color:#888;">無敵雲課程管理系統</span>
</div>

